import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const AdminPractitionersLogs = withLazyFallback(
  () => import('components/admin/pages/Practitioners/Logs')
);
const AdminPractitionersPractices = withLazyFallback(
  () => import('components/admin/pages/Practitioners/Practices')
);
const PractitionersBasicInfo = withLazyFallback(
  () => import('components/admin/pages/Practitioners/PractitionersBasicInfo')
);
const PractitionersPatients = withLazyFallback(
  () => import('components/admin/pages/Practitioners/PractitionersPatients')
);
const Practitioners = withLazyFallback(
  () => import('components/admin/pages/Practitioners/PractitionersTable')
);
const PrescriptionManagement = withLazyFallback(
  () => import('components/admin/pages/Practitioners/PrescriptionManagement')
);
const AdminPractitionersSettings = withLazyFallback(
  () => import('components/admin/pages/Practitioners/components/Settings')
);
const NewPractitionerContainer = withLazyFallback(
  () => import('components/admin/pages/Practitioners/new_practitioner/indexContainer')
);
const PractitionerProfile = withLazyFallback(
  () => import('components/admin/pages/Practitioners/profile')
);

const ADMIN_PRACTITIONERS = [
  {
    path: 'practitioners',
    element: <Practitioners />,
    handle: { title: 'Practitioners' },
    children: [
      {
        path: ':id',
        element: <PractitionerProfile />,
        children: [
          { path: '', element: <PractitionersBasicInfo />, handle: { title: 'Basic Info' } },
          { path: 'patients', element: <PractitionersPatients />, handle: { title: 'Patients' } },
          {
            path: 'eprescribe',
            element: <PrescriptionManagement />,
            handle: { title: 'ePrescribe' }
          },
          {
            path: 'practices',
            element: <AdminPractitionersPractices />,
            handle: { title: 'Practices' }
          },
          {
            path: 'settings',
            element: <AdminPractitionersSettings />,
            handle: { title: 'Settings' }
          },
          { path: 'logs', element: <AdminPractitionersLogs />, handle: { title: 'Logs' } },
          { path: '*', element: <NotFound /> }
        ]
      },
      { path: 'new', element: <NewPractitionerContainer />, handle: { title: 'New Practitioner' } },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_PRACTITIONERS;
